$(document).ready(function() {
   return SwellConfig.LocalStorage.initializeLocalStorage();
});

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && (window.location.pathname === '/account' || window.location.pathname === '/')) {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };

}).call(this);